import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WordCounterPipe } from './word-counter.pipe';
import { NoSanitizePipe } from './no-sanitize.pipe';
import { TimerPipe } from './timer.pipe';
import { ConvertToPersianPipe } from './convert-to-persian.pipe';
import { JalaliMomentPipe } from './jalali-moment.pipe';
import { MakePlanPipe } from './make-plan.pipe';
import { LineBreaksPipe } from './line-breaks.pipe';


@NgModule({
  declarations: [
    WordCounterPipe,
    NoSanitizePipe,
    TimerPipe,
    ConvertToPersianPipe,
    JalaliMomentPipe,
    MakePlanPipe,
    LineBreaksPipe,

  ],
  imports: [
    CommonModule,
  ],
  exports: [
    WordCounterPipe,
    NoSanitizePipe,
    TimerPipe,
    ConvertToPersianPipe,
    JalaliMomentPipe,
    MakePlanPipe,
    LineBreaksPipe
  ]
})
export class PipsModule { }